export default {
  toggleSetMode(state) {
    state.config.setMode === false
      ? (() => {
          state.config.setMode = true;
          state.config.nudgeMode = false;
          state.config.clearMode = false;
        })()
      : (state.config.setMode = false);
  },
  toggleClearMode(state) {
    state.config.clearMode === false
      ? (() => {
          state.config.clearMode = true;
          state.config.nudgeMode = false;
          state.config.setMode = false;
        })()
      : (state.config.clearMode = false);
  },
  toggleNudgeMode(state) {
    state.config.nudgeMode === false
      ? (() => {
          state.config.nudgeMode = true;
          state.config.setMode = false;
          state.config.clearMode = false;
        })()
      : (state.config.nudgeMode = false);
  },
  addVideo(state, payload) {
    // Limit video memory to maximum 20
    if (state.volatile.videos.length < 20) {
      state.volatile.videos = [
        ...state.volatile.videos,
        {
          id: payload.id,
          title: payload.title,
          cuePoints: state.volatile.pads
        }
      ];
    } else {
      // If memory is full shift videos array and add new one
      state.volatile.videos = [
        ...state.volatile.videos.shift(),
        {
          id: payload.id,
          title: payload.title,
          cuePoints: state.volatile.pads
        }
      ];
    }
  },
  replacePads(state, payload) {
    state.volatile.pads = payload; // Replace current cue points with new cue points
  },
  replaceVolatile(state, payload) {
    // Replace the state object with the stored objects
    state.volatile = payload;
  },
  overwriteExistingVideo(state, payload) {
    state.memoryPads["memory" + payload.memorySlot].content.forEach(video => {
      if (video.id == payload.id) {
        video.cuePoints = state.volatile.pads;
      }
    });
  },
  addVideoToMemory(state, payload) {
    state.memoryPads["memory" + payload.memorySlot].content = [
      ...state.memoryPads["memory" + payload.memorySlot].content,
      {
        id: payload.id,
        title: payload.title,
        cuePoints: state.volatile.pads
      }
    ];
  },
  setActiveMemory(state, memoryNr) {
    Object.keys(state.memoryPads).forEach(key => {
      if (state.memoryPads[key].nr === memoryNr) {
        state.memoryPads[key].active = true;
      } else {
        state.memoryPads[key].active = false;
      }
    });
  },
  initializeStore(state) {
    // Check if volatile memory is stored in memory
    if (localStorage.getItem("volatile")) {
      // Replace the volatile memory object with the stored state
      state.volatile = JSON.parse(localStorage.getItem("volatile"));
    }
    // Check if persistent memory slots are present
    Object.keys(state.memoryPads).forEach(key => {
      if (localStorage.getItem("memory" + state.memoryPads[key].nr)) {
        // Replace the persistent memory object with the stored state
        state.memoryPads[
          "memory" + state.memoryPads[key].nr
        ].content = JSON.parse(
          localStorage.getItem("memory" + state.memoryPads[key].nr)
        );
        state.memoryPads[key].used = true;
      }
    });
  },
  clearCopy(state, memoryNr) {
    state.memoryPads["memory" + memoryNr].content = []; // Replace local copy with empty Object
    state.memoryPads["memory" + memoryNr].used = false; // Remove used marker from memoryPad
  },
  clearCuePoint(state, note) {
    // Search for the right note and clear cue point
    state.volatile.pads.forEach(pad => {
      if (pad.note === note) {
        pad.cuePoint = 0; // clear cue point
      }
    });
  },
  clearCuePoints(state) {
    state.volatile.pads.forEach(pad => {
      pad.cuePoint = 0; // clear all cue points
    });
  },
  setNote(state, note) {
    state.volatile.currentNote = note;
  },
  setCurrentMidiInput(state, value) {
    state.volatile.currentMidiInput = value;
  },
  setCurrentTitle(state, title) {
    state.volatile.currentVidTitle = title;
  },
  toggleMenu(state) {
    state.config.menuActive == true
      ? (state.config.menuActive = false)
      : (state.config.menuActive = true);
  },
  closeMenu(state) {
    state.config.menuActive = false;
  },
  resetStore(state) {
    localStorage.removeItem("volatile"); // Clear store in local storage
    localStorage.removeItem("store"); // Clear legacy store in local storage
    Object.keys(state.memoryPads).forEach(key => {
      state.memoryPads[key].content = {}; // Replace memory content with empty Object
      state.memoryPads[key].used = false; // Remove used marker
      localStorage.removeItem("memory" + state.memoryPads[key].nr); // Clear memory in local storage
    });
  }
};
